// extracted by mini-css-extract-plugin
module.exports = {"icon":"strategy_icon__hCco6","feature":"strategy_feature__VXJ_W","small":"strategy_small__0DRy7"};